import { useQueryClient } from '@tanstack/react-query'
import { useTRPC } from '@/trpc/react.ts'

export function useContractDocumentInvalidation() {
  const trpc = useTRPC()
  const cache = useQueryClient()
  return () =>
    Promise.all([
      cache.invalidateQueries(trpc.contract.document.list.queryFilter()),
      cache.invalidateQueries(trpc.contract.document.detail.queryFilter()),
      cache.invalidateQueries(trpc.order.contracts.list.queryFilter()),
      cache.invalidateQueries(trpc.order.contracts.summary.queryFilter()),
      cache.invalidateQueries(trpc.order.contracts.documents.queryFilter()),
      cache.invalidateQueries(trpc.order.rental.currentContract.queryFilter())
    ])
}
